import React from "react";

import UpsellContainer from "./upsell/UpsellContainer";

import { useAvailableAdditionalEquipment } from "@hooks/useAvailableAdditionalEquipment";
import { useAvailableServices } from "@hooks/useAvailableServices";

import { useTranslation } from "@lib/i18n";

import { dealItemType } from "@types";

const DealSummaryUpsellCarousels = ({ deal }) => {
  const { t } = useTranslation();
  const availableEquipment = useAvailableAdditionalEquipment(deal);
  const availableServices = useAvailableServices(deal);
  return (
    <>
      <UpsellContainer
        options={availableEquipment}
        title={t("basket.additionalEquipment")}
      />
      <UpsellContainer
        options={availableServices}
        title={t("basket.services")}
      />
    </>
  );
};

DealSummaryUpsellCarousels.propTypes = {
  deal: dealItemType,
};

export default DealSummaryUpsellCarousels;
